import { createSelector } from 'reselect'
import { RegisterAppState } from './types'

export const getState = (state: RegisterAppState) => state.ui.register

export const getRegister = createSelector(getState, state => state.form)
